import { TRANSCRIPTION_CLOSE, TranscriptionConnectError } from "@/api";

/** What went wrong with dictation; each has a translated message (chat:composer.voice.*). */
export type DictationError =
  | "unsupported"
  | "permissionDenied"
  | "noMicrophone"
  | "notConfigured"
  | "connection"
  | "failed";

/** getUserMedia's DOMException names → what the user can do about it. */
export function micErrorKind(error: unknown): DictationError {
  if (!(error instanceof DOMException)) return "failed";
  if (error.name === "NotAllowedError" || error.name === "SecurityError") return "permissionDenied";
  if (error.name === "NotFoundError" || error.name === "OverconstrainedError") return "noMicrophone";
  return "failed";
}

/** Why the transcription socket closed while dictating. */
export function closeErrorKind(code: number): DictationError {
  if (code === TRANSCRIPTION_CLOSE.notConfigured) return "notConfigured";
  if (code === TRANSCRIPTION_CLOSE.internalError) return "failed";
  return "connection";
}

/** Anything that stopped dictation from starting once the microphone was granted. */
export function startErrorKind(error: unknown): DictationError {
  return error instanceof TranscriptionConnectError ? closeErrorKind(error.code) : "failed";
}
